import { Injectable } from '@angular/core';
import { FilterFieldValue } from '../../covance-filter';
import { OnScreenResultsFilterDefenitions } from './on-screen-results-filter-defenitions';

export interface FilterStorage {
    filterFieldsData: FilterFieldValue[];
    subjectFilter: FilterFieldValue;
}

@Injectable()
export class InvestigatorLabTestResultsFilterStorage implements FilterStorage {

    public filterFieldsData: FilterFieldValue[];

    public  readonly subjectFilter: FilterFieldValue;

    constructor(
        private readonly onScreenResultsFilterDefenitions: OnScreenResultsFilterDefenitions,
    ) {
        this.filterFieldsData = this.onScreenResultsFilterDefenitions.siteDataFilterFieldDefs.map(def => { return { def: def } as FilterFieldValue; });
        this.subjectFilter = this.filterFieldsData.find(f => f.def.title === 'Subject');
     }
}